import {useContext} from 'react'
import {AvailablePropertiesContext} from "../context/AvailablePropertiesContextProvider";

export function useAvailablePropertiesContext()
{
    const context = useContext(AvailablePropertiesContext);

    if (!context) {
        throw new Error(
            "useAvailablePropertiesContext must be used within the scope of AvailablePropertiesContextProvider"
        );
    }

    return context;
}